app.controller('Debug', function($scope, $http, _$toast, $rootScope) {

  $scope.epuap = {};

  $scope.info = {
    epuap: {
      showResponse: false,
      responseContent: ""
    }
  };

  $scope.checkForm = function(form){
    if (form.$valid) {
        return true;
    } else {
        angular.forEach(form.$error, function(field) {
            angular.forEach(field, function(f) {
                f.$setDirty();
                f.$setTouched();
            });
        });
        $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
        return false;
    }
  };

  $scope.sendEpuap = function(){
      $scope.info.epuap = {
        showResponse: false,
        responseContent: ""
      };
      $scope.showLoader = true;
      $http.post('/administration/debug/epuap', $scope.epuap)
          .success(function(result) {
              $scope.showLoader = false;
              $scope.info.epuap.responseContent = result.msg;
              $scope.info.epuap.showResponse = true;
          });
  };

});
